module.exports = __webpack_public_path__ + "img/genesis_g80.c61258a5.jpg";